import React from 'react';
import { servicesData } from '../data/mock';
import { Crown, Target, TrendingUp, Users, Sparkles, CheckCircle, Calendar, Settings } from 'lucide-react';

const iconMap = {
  crown: Crown,
  target: Target,
  trendingUp: TrendingUp,
  users: Users,
  sparkles: Sparkles,
  checkCircle: CheckCircle,
  calendar: Calendar,
  settings: Settings
};

const Services = () => {
  return (
    <section id="services" className="py-24 lg:py-32 bg-gradient-to-b from-black via-gray-900/50 to-black relative overflow-hidden">
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        
        {/* Section Title */}
        <div className="text-center mb-16 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            {servicesData.sectionTitle}
          </h2>
          <div className="w-20 h-1 bg-accent-red mx-auto"></div>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 max-w-7xl mx-auto">
          {servicesData.services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div 
                key={service.id}
                className="bg-gradient-to-br from-black/60 to-gray-900/60 backdrop-blur-sm border border-gold/10 rounded-2xl p-8 hover:border-gold/30 transition-all hover:-translate-y-1 group"
              >
                {/* Icon */}
                <div className="w-14 h-14 bg-gold/10 rounded-xl flex items-center justify-center mb-6 group-hover:bg-gold/20 transition-colors">
                  <IconComponent className="text-gold" size={26} />
                </div>

                {/* Title */}
                <h3 className="text-xl lg:text-2xl font-bold text-white mb-4 group-hover:text-gold transition-colors">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-white/70 leading-relaxed text-base">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
